import useSWRImmutable from 'swr'
import { fetchGetCoordinateComments } from '../lib/fetchGetCoordinateComments'
import { getCoordinateCommentsKey } from '../lib/getCoordinateCommentsKey'

const INITIAL_COMMENT_COUNT = 8

export const useComment = (coordinateId: number) => {
  const { data: comments } = useSWRImmutable(
    getCoordinateCommentsKey({
      coordinate_id: coordinateId.toString(),
      count: INITIAL_COMMENT_COUNT,
    }),
    fetchGetCoordinateComments
  )

  /**
   * コメントの総数
   */
  const totalCommentsCount = comments?.total_count ?? 0

  /**
   * 8件以上のコメントがあるかどうか
   */
  const hasMoreComments = totalCommentsCount > INITIAL_COMMENT_COUNT

  /**
   * 表示コメント数を引いた残りコメント数
   */
  const restCommentsCount = totalCommentsCount - INITIAL_COMMENT_COUNT

  return {
    comments: comments?.coordinate_comments ?? [],
    hasMoreComments,
    restCommentsCount,
    totalCommentsCount,
  }
}
